import FleetDashboardOpenSearch from "./FleetDashboardOpenSearch";

export { FleetDashboardOpenSearch };
export default FleetDashboardOpenSearch;
